var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('navbar-component',{attrs:{"logoColor":_vm.logoColor,"loginLink":_vm.loginLink,"signupLink":_vm.signupLink,"wordingSignUp":_vm.wordingSignUp,"showAuth":_vm.showAuth}}),_c('main',{staticClass:"overflow-hidden"},[_vm._t("default")],2),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }